import { render, staticRenderFns } from "./address-add.vue?vue&type=template&id=bb28e780"
import script from "./address-add.vue?vue&type=script&lang=js"
export * from "./address-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports